<template>
    <div class="menu-part">
        <ul class="nav">
            <li><a href='javascript:void(0)' @click="handleClick(1)">Homepage</a></li>
            <li><a href='javascript:void(0)' @click="handleClick(6)">Quick Start</a></li>
            <li><a href='javascript:void(0)' @click="handleClick(2)">Preprocess</a></li>
            <li><a href='javascript:void(0)' @click="handleClick(3)">Simulation</a></li>
            <li><a href='javascript:void(0)' @click="handleClick(4)">Download</a></li>
            <li><a href='javascript:void(0)' @click="handleClick(5)">Contact Us</a></li>
            <!-- <li><a href='javascript:void(0)' @click="handleClick(2)">Installation</a></li>
            <li><a href='javascript:void(0)' @click="handleClick(3)">Documentation</a></li>
            <li><a href='javascript:void(0)' @click="handleClick(4)">Example</a></li>
            <li><a href='javascript:void(0)' @click="handleClick(5)">Simulator</a></li>
            <li><a href='javascript:void(0)' @click="handleClick(6)">Contact</a></li> -->
        </ul>
    </div>
</template>

<script>
export default {
     methods: {
      handleClick(value){
          console.log(value)
          switch(value){
              case 1:
                  this.$router.push('./');
                  break;
              case 2:
                  this.$router.push('./Preprocess');
                  break;
              case 3:
                  this.$router.push('./Simulation');
                  break;
              case 4:
                  this.$router.push('./Download');
                  break;
              case 5:
                  this.$router.push('./Contact');
                  break;
                case 6:
                  this.$router.push('./Start');
                  break;
            //   case 2:
            //       this.$router.push('./Install');
            //       break;
            //   case 3:
            //       this.$router.push('./Document');
            //       break;
            //   case 4:
            //       this.$router.push('./Example');
            //       break;
            //   case 5:
            //       this.$router.push('./Simulator');
            //       break;
            //   case 6:
            //       this.$router.push('./Contact');
            //       break;
          }
      }
    }
}
</script>

<style scoped>
.menu-part{
    box-sizing: border-box;
    border:1px #D1D3D4 solid;
    width:1200px;
    margin:0 auto;
    display:flex;
    padding: 0;
    background:rgb(0,100,164);
}

.nav{
    list-style:none;
    margin:0px;
    /* margin:0px; 在这里设置margin可以让a block占满*/
}
.nav li{
    float:left;
    

}
.nav li:first-child{
    border-left:2px white solid;
}
.nav li a{
    display: block;
    border-right:2px white solid;
    color:white;
    /* border-left:1px white solid; */
    text-decoration: none;
    width:170px;
    padding:8px;
    /* background-color: red; */
    /* background-color:inherit; */
    text-transform: uppercase;
    font-size: 12px;
    line-height: 20px;
    font-weight: 800;
    letter-spacing: 1px;
}
.nav li a:hover{
    opacity: 0.8;
}
</style>


// WEBPACK FOOTER //
// src/layout/menu.vue